import styles from "./NewBusinessCard.module.scss";
import avaIcon from "./icons/ava_gift.png";
import arrowIcon from "../../../icons/arrow.png";
import { FC } from "react";
import { ILibBusiness } from "../../../redux/businesses";

interface INewBusinessCardProps extends ILibBusiness {};

export const NewBusinessCard: FC<INewBusinessCardProps> = ({ name }) => {
    return (
        <div className={styles.tasksWrapper}>
            <div className={styles.taskItem}>
                <div className={`${styles.iconWrapper} ${styles.iconType2}`}>
                    <img
                        src={avaIcon}
                        alt={ name }
                        className={styles.icon}
                    />
                </div>

                <div className={styles.taskDetails}>
                    <h3 className={styles.taskTitle}>{ name }</h3>
                    <p className={styles.taskStatus}>
                        Бизнес-модель — это анализ и схематичное описание
                    </p>
                </div>

                <img src={arrowIcon} alt="arrow" className={styles.arrowIcon} />
            </div>
        </div>
    );
};